/** Report issue entry and current UI session (STUDIO-HOME-004). */
import { create } from "zustand";

export type ReportIssueEntry = "sidebar" | "toast";
interface ReportIssueState {
  open: boolean;
  entry: ReportIssueEntry;
  modalSessionId: number;
  sentSessionId: number | null;
  sentAt: number | null;
  openReportIssue: (entry: ReportIssueEntry) => void;
  closeReportIssue: () => void;
  markReportSent: (sessionId: number) => void;
}

export const useReportIssueStore = create<ReportIssueState>((set) => ({
  open: false,
  entry: "sidebar",
  modalSessionId: 0,
  sentSessionId: null,
  sentAt: null,
  openReportIssue: (entry) => set((state) => ({
    open: true, entry, modalSessionId: state.modalSessionId + 1,
  })),
  closeReportIssue: () => set({ open: false }),
  markReportSent: (sessionId) => set((state) =>
    state.open && state.modalSessionId === sessionId
      ? { sentSessionId: sessionId, sentAt: Date.now() }
      : state,
  ),
}));

export const openReportIssue = (entry: ReportIssueEntry): void =>
  useReportIssueStore.getState().openReportIssue(entry);
